import { render, staticRenderFns } from "./LandfillBalance.vue?vue&type=template&id=d02badd4&scoped=true"
import script from "./LandfillBalance.vue?vue&type=script&lang=js"
export * from "./LandfillBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02badd4",
  null
  
)

export default component.exports